import { render } from "./tabs.vue?vue&type=template&id=68d0a0dd&scoped=true&ts=true"
import script from "./tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./tabs.vue?vue&type=script&setup=true&lang=ts"

import "./tabs.vue?vue&type=style&index=0&id=68d0a0dd&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d0a0dd"],['__file',"src/views/collect/tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68d0a0dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68d0a0dd', __exports__)) {
    console.log('reload')
    api.reload('68d0a0dd', __exports__)
  }
  
  module.hot.accept("./tabs.vue?vue&type=template&id=68d0a0dd&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('68d0a0dd', render)
  })

}


export default __exports__